import { kioskApi } from '../axios.js';
export const kioskTypeApi = {
    getKioskTypes: async () => {
        console.log('[kioskTypeApi] Fetching kiosk types...');
        try {
            const response = await kioskApi.get('/admin/kiosk-types');
            // Log full response for debugging
            console.log('[kioskTypeApi] Full response object:', {
                status: response.status,
                statusText: response.statusText,
                headers: response.headers,
                dataType: Array.isArray(response.data) ? 'array' : typeof response.data,
                dataKeys: Object.keys(response.data || {}),
                data: response.data
            });
            // Check if data is nested under a property
            let kioskTypes = response.data;
            if (response.data && !Array.isArray(response.data) && response.data.data) {
                console.log('[kioskTypeApi] Found kiosk types in response.data.data');
                kioskTypes = response.data.data;
            }
            // Ensure we have an array
            if (!Array.isArray(kioskTypes)) {
                console.error('[kioskTypeApi] Response data is not an array:', kioskTypes);
                throw new Error('Invalid response format: expected array of kiosk types');
            }
            if (!response.data) {
                console.error('[kioskTypeApi] No data in response');
                return {
                    ...response,
                    data: []
                };
            }
            // Ensure we always return an array in the response data
            const types = Array.isArray(response.data) ? response.data : [response.data];
            // Transform data to ensure consistent format
            const transformedData = types.map((type) => ({
                id: type.id || type.config_identifier,
                config_identifier: type.config_identifier,
                name: type.name,
                description: type.description,
                required_inputs: type.required_inputs || [],
                created_at: type.created_at,
                updated_at: type.updated_at
            }));
            // Return the AxiosResponse with transformed data
            return {
                ...response,
                data: transformedData
            };
        }
        catch (error) {
            console.error('[kioskTypeApi] Error getting kiosk types:', {
                message: error instanceof Error ? error.message : 'Unknown error',
                stack: error instanceof Error ? error.stack : undefined,
                response: error?.response?.data
            });
            throw error;
        }
    },
    reseedKioskTypes: async () => {
        console.log('[kioskTypeApi] Reseeding kiosk types...');
        try {
            const response = await kioskApi.post('/admin/kiosk-types/reseed');
            console.log('[kioskTypeApi] Reseed successful');
            return response;
        }
        catch (error) {
            console.error('[kioskTypeApi] Error reseeding kiosk types:', {
                message: error instanceof Error ? error.message : 'Unknown error',
                stack: error instanceof Error ? error.stack : undefined,
                response: error?.response?.data
            });
            throw error;
        }
    }
};
